export const navigation = [
  { name: 'Home', path: '/' },
]

export const userNavigation = [
  { name: 'Settings', path: '/settings' },
  { name: 'Logout', path: '/logout' },
]
